module.exports = __webpack_public_path__ + "img/web-hosting.7848b52a.svg";